import { get, post } from 'util/request';
import { saveUserDataStorage, removeUserDataStorage } from 'util/storege';
import { message } from 'antd';
import { emitUserDataEvent } from 'util/custom-event';
import APIS from 'api/index';

/**
 * 用户登录
 * @param {string} username 账号
 * @param {string} password 密码
 */
function requestUserLogin(username, password) {
  // saveUserDataStorage({username: 'jinmu'});
  // emitUserDataEvent('login');
  const data = {
    username,
    password,
  };
  return post(APIS.LOGIN, data).then(userData => {
    if (userData.code == '200') {
      message.success('登录成功');
      saveUserDataStorage(userData.data);
      emitUserDataEvent('login');
    } 
    return userData;
  });
}

/**
 * 用户登出
 */
function userLogout() {
  const url = '/user/logout.do';
  removeUserDataStorage();
  emitUserDataEvent('logout');
  return '退出成功';
  // return post(url).then(() => {
  // });
}

/**
 * 获取用户列表
 */
function requestUserList(pageSize, pageNum) {
  const url = '/manage/user/list.do';
  return get(url, { pageSize, pageNum });
}

export {
  requestUserLogin,
  userLogout,
  requestUserList,
};
